<div class="vamp-page">
  <payarc-page-header title="VAMP Details" titleId="heading_vamp_details"></payarc-page-header>

  <!-- VAMP Ratio gauge/limit callout: design/prototype/vamp.html flags this whole block
       CONCEPT — NOT IN CURRENT APP (no ratio-vs-limit/trend data exists on this model;
       displaySummary only has the plain vamp_ratio_pct number below). Not built. -->

  <!-- ===== Summary — single details card; zeros/defaults when empty ===== -->
  <payarc-detail-card title="Summary" class="vamp-summary" [rows]="summaryRows"></payarc-detail-card>

  <!-- Monthly VAMP (trailing 6 months, per-month sale/fraud/chargeback/ratio breakdown):
       design/prototype/vamp.html flags this CONCEPT — NOT IN CURRENT APP too. No
       monthly-aggregation endpoint exists here (only the point-in-time /vamp/summary and
       the transaction-level /vamp/transactions this page already uses below). Not built. -->

  <!-- ===== TC-40 transactions — same shell as Card Transactions (ws:rollout) ===== -->
  <payarc-filter-bar class="vamp-filter-row">
    <payarc-search placeholder="Search" [value]="searchText" (valueChange)="searchText = $event; searchHits.next()"></payarc-search>
    <input [matDatepicker]="df" [(ngModel)]="from" [max]="to" (click)="df.open()"
           class="pa-input" style="width:150px" placeholder="From" aria-label="From date" readonly>
    <mat-datepicker #df (closed)="onDateChange()"></mat-datepicker>
    <input [matDatepicker]="dt" [(ngModel)]="to" [min]="from" [max]="today" (click)="dt.open()"
           class="pa-input" style="width:150px" placeholder="To" aria-label="To date" readonly>
    <mat-datepicker #dt (closed)="onDateChange()"></mat-datepicker>
    <ng-container actions>
      <button type="button" payarcButton="primary" [disabled]="!totalRecords" (click)="export('csv')">Export CSV</button>
      <button type="button" payarcButton="primary" [disabled]="!totalRecords" (click)="export('xls')">Export XLS</button>
    </ng-container>
  </payarc-filter-bar>

  <payarc-section-card [flush]="true">
    <payarc-table class="vamp-table">
      <thead>
        <tr>
          <th *ngFor="let col of columns" [style.min-width.px]="col.width" [class.num]="col.type === 'money'"
              [attr.aria-sort]="sortAriaFor(col.key)">
            <button type="button" class="pa-th-sort" (click)="setSorting(col.key)">{{ col.label }}
              <payarc-sort-icon [direction]="sortDirectionFor(col.key)"></payarc-sort-icon></button>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="loadFlag2">
          <tr class="pa-skeleton-row" *ngFor="let r of [1,2,3,4,5]">
            <td *ngFor="let c of columns"><span class="pa-skeleton-bar"></span></td>
          </tr>
        </ng-container>

        <ng-container *ngIf="!loadFlag2 && rows.length">
          <tr *ngFor="let tx of rows">
            <td *ngFor="let col of columns" [attr.data-th]="col.label" [class.num]="col.type === 'money'" [ngSwitch]="col.type">
              <ng-container *ngSwitchCase="'date'">{{ tx[col.key] ? (tx[col.key] | date:'MM/dd/yyyy') : '--' }}</ng-container>
              <ng-container *ngSwitchCase="'money'">{{ tx[col.key] != null ? (tx[col.key] | currency:'USD':'symbol':'1.2-2') : '--' }}</ng-container>
              <ng-container *ngSwitchDefault>{{ tx[col.key] != null && tx[col.key] !== '' ? tx[col.key] : '--' }}</ng-container>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </payarc-table>

    <!-- Outside the (very wide, horizontally scrolling) table so it centres in the visible card. -->
    <payarc-empty-state *ngIf="!loadFlag2 && !rows.length" title="No VAMP transactions" [message]="noDataMessage"></payarc-empty-state>

    <div class="vamp-pager-row" *ngIf="!loadFlag2 && totalRecords">
      <!-- Same rows-per-page control as the other ws:rollout lists (e.g. customer-list). -->
      <label class="vamp-pager-row__limit">
        Rows per page
        <select class="pa-input" [(ngModel)]="limit" (change)="setUrl()">
          <option *ngFor="let no of limitArray" [ngValue]="no">{{ no }}</option>
        </select>
      </label>
      <payarc-pager
        [rangeLabel]="pagerRangeLabel"
        [pages]="pagerPages"
        [currentPage]="page"
        [disablePrev]="page <= 1"
        [disableNext]="page >= totalPages"
        (prev)="prevPage()"
        (next)="nextPage()"
        (pageSelect)="goToPage($event)"
      ></payarc-pager>
    </div>
  </payarc-section-card>

  <div class="vamp-disclaimer">
    To inquire about a specific transaction or dispute a transaction, contact
    <a [href]="disputeMailto">Risk&#64;payarc.com</a>
  </div>
</div>
